import i18n from "i18next";

import type { CellValue } from "../Table/types/types";
import { HtmlColorBadgeStyle } from "./HtmlColorBadgeStyle";

interface CellColorBadgeProps {
    cellValue: CellValue;
}

export const HtmlCampaignStatusColorBadgeComponent = ({ cellValue }: CellColorBadgeProps) => {
    return (
        <HtmlColorBadgeStyle
            className={(() => {
                switch (cellValue) {
                    case undefined:
                    case null:
                    case "CREATED":
                        return "aevi-status-badge aevi-created";
                    case "GENERATING":
                        return "aevi-status-badge aevi-generated";
                    case "WAITING":
                        return "aevi-status-badge aevi-generated";
                    case "UPDATED":
                        return "aevi-status-badge aevi-updated";
                    case "STOPPED":
                        return "aevi-status-badge aevi-stopped";
                    case "FAILED":
                        return "aevi-status-badge aevi-failed";
                    default:
                        return "aevi-status-badge aevi-active";
                }
            })()}
        >
            <sup>
                {(() => {
                    switch (cellValue) {
                        case undefined:
                        case null:
                        case "CREATED":
                            return i18n.t("enum.campaignState.created");
                        case "GENERATING":
                            return i18n.t("enum.campaignState.generating");
                        case "WAITING":
                            return i18n.t("enum.campaignState.waiting");
                        case "UPDATED":
                            return i18n.t("enum.campaignState.updated");
                        case "STOPPED":
                            return i18n.t("enum.campaignState.stopped");
                        case "FAILED":
                            return i18n.t("enum.campaignState.failed");
                        default:
                            return i18n.t("enum.status.active");
                    }
                })()}
            </sup>
        </HtmlColorBadgeStyle>
    );
};
